/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-floating-promises */

// gimme: conversations-thread-view 06/30/2021 cfef6b9a8b3badc65b082ffd722b737fa8d16bdf

import PropTypes from 'prop-types';
import { useCallback, useState, useContext } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import get from 'transmute/get';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Se... Remove this comment to see the full error message
import SelectFileDropdown from './SelectFileDropdown';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Up... Remove this comment to see the full error message
import UploadFileButton from './UploadFileButton';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Se... Remove this comment to see the full error message
import SelectExistingFileButton from './SelectExistingFileButton';
import { getInsertAttachment, getClickedAttachmentButton } from '../../../usage-tracking/events/editorInteractions';
import { createFileMapping } from '../../../attachments/protected/clients';
import { COMPOSITION_THREAD_ID } from 'conversations-thread-data/communicator/constants/compositionThreadId';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  attachmentCountLimit: PropTypes.number.isRequired,
  attachments: ImmutablePropTypes.listOf(PropTypes.object),
  fileUploadsInProgCount: PropTypes.number,
  onAttach: PropTypes.func.isRequired,
  renderExistingFileSelect: PropTypes.func,
  threadId: PropTypes.string,
  uploadFile: PropTypes.func
};
const AttachmentButton = ({
  attachments,
  attachmentCountLimit,
  onAttach,
  renderExistingFileSelect,
  threadId,
  fileUploadsInProgCount,
  uploadFile
}) => {
  const [open, setOpen] = useState(false);
  const [selectingExistingFile, setSelectingExistingFile] = useState(false);
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const handleAttach = useCallback(attachment => {
    trackEvent(getInsertAttachment({
      file: attachment
    }));
    onAttach(attachment);
  }, [onAttach, trackEvent]);
  const handleSelect = useCallback(files => {
    setOpen(false);
    setSelectingExistingFile(false);
    Array.prototype.slice.call(files).forEach(file => uploadFile(file));
  }, [uploadFile, setOpen]);
  const handleSelectExistingFile = useCallback(attachment => {
    setSelectingExistingFile(false);
    handleAttach(attachment);
    if (threadId !== COMPOSITION_THREAD_ID) {
      createFileMapping({
        threadId,
        fileId: get('id', attachment)
      });
    }
  }, [handleAttach, setSelectingExistingFile, threadId]);
  const handleClickToSelectExistingFile = useCallback(() => {
    setOpen(false);
    setSelectingExistingFile(true);
  }, [setOpen, setSelectingExistingFile]);
  const handleCloseExistingFileSelect = useCallback(() => {
    setSelectingExistingFile(false);
  }, [setSelectingExistingFile]);
  const handleOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (value) trackEvent(getClickedAttachmentButton());
    setOpen(value);
  }, [setOpen, trackEvent]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.prosemirror.plugins.attachments.dropdown-label"
    }),
    open: open ? false : undefined,
    children: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsxs(SelectFileDropdown, {
        attachments: attachments,
        attachmentCountLimit: attachmentCountLimit,
        fileUploadCount: fileUploadsInProgCount || 0,
        onOpenChange: handleOpenChange,
        open: open,
        children: [renderExistingFileSelect ? /*#__PURE__*/_jsx(SelectExistingFileButton, {
          onClick: handleClickToSelectExistingFile
        }) : null, /*#__PURE__*/_jsx(UploadFileButton, {
          onSelectFiles: handleSelect
        })]
      }), selectingExistingFile && renderExistingFileSelect && renderExistingFileSelect({
        onClose: handleCloseExistingFileSelect,
        onSelect: handleSelectExistingFile
      })]
    })
  });
};
AttachmentButton.propTypes = propTypes;
export default AttachmentButton;